<template>
  <v-text-field
    :id="id"
    :label="label"
    v-model="currentValue"
    :type="show1 ? 'text' : fieldTextType(dataType)"
    @input="handleChange"
    :required="requiredField(access)"
    :readonly="readonlyField(access)"
    :append-icon="getIcon()"
    :filled="readonlyField(access) || queryFlag"
    @click:append="show1 = !show1"
    :hint="hint"
    :rules="rules"
    @keydown="k => handleKeyDown(k, id)"
    autocomplete="off"
    v-show="!hiddenField(access)"
  />
</template>

<script>
export default {
  name: "PasswordField",
  props: ["label", "value", "access", "pattern", "id", "name", "rules", "dataType", "hint", "queryFlag"],
  data() {
    return {
      show1: false,
      defaultValue: this.value,
      currentValue: this.value,
    };
  },
  methods: {
    getIcon() {
      return this.readonlyField(this.access) ? null : (this.show1 ? 'mdi-eye' : 'mdi-eye-off');
    },
    handleChange() {
      const data = {
        value: this.currentValue,
        id: this.id,
      };
      this.$emit("field-change", data);
    },
    handleKeyDown(key, id) {
      this.$emit('handle-key-down', key.key, id);
    },
    setValue(value) {
      this.currentValue = value;
      this.handleChange();
    }
  },
};
</script>

<style scoped>
</style>